import api from './api';
import { SpecialDate } from '@/types/specialDate';

export const specialDatesApi = {
    // Tüm özel tarihleri listele (admin)
    async getAllSpecialDates(): Promise<SpecialDate[]> {
        try {
            console.log('📡 Calling GET /admin/special-dates');
            const response = await api.get('/admin/special-dates');
            console.log('📥 Response:', response.data);
            return response.data;
        } catch (error: any) {
            console.error('❌ Special Dates API Error:', error.response || error);
            throw new Error(error.response?.data?.error || 'Özel tarihler listesi yüklenemedi');
        }
    },

    // Özel tarih detayı getir
    async getSpecialDate(specialDateId: string): Promise<SpecialDate> {
        try {
            const response = await api.get(`/admin/special-dates/${specialDateId}`);
            return response.data;
        } catch (error: any) {
            console.error('Error fetching special date:', error);
            throw new Error(error.response?.data?.error || 'Özel tarih yüklenemedi');
        }
    },

    // Yeni özel tarih oluştur (admin)
    async createSpecialDate(specialDateData: Omit<SpecialDate, 'id' | 'createdAt' | 'updatedAt'>): Promise<SpecialDate> {
        try {
            const response = await api.post('/admin/special-dates', specialDateData);
            return response.data;
        } catch (error: any) {
            console.error('Error creating special date:', error);
            const errorMessage = error.response?.data?.details || error.response?.data?.error || 'Özel tarih oluşturulamadı';
            throw new Error(errorMessage);
        }
    },

    // Özel tarih güncelle (admin)
    async updateSpecialDate(specialDateId: string, specialDateData: Partial<Omit<SpecialDate, 'id' | 'createdAt' | 'updatedAt'>>): Promise<SpecialDate> {
        try {
            const response = await api.put(`/admin/special-dates/${specialDateId}`, specialDateData);
            return response.data;
        } catch (error: any) {
            console.error('Error updating special date:', error);
            throw new Error(error.response?.data?.error || 'Özel tarih güncellenemedi');
        }
    },

    // Özel tarih sil (admin)
    async deleteSpecialDate(specialDateId: string): Promise<{ message: string }> {
        try {
            const response = await api.delete(`/admin/special-dates/${specialDateId}`);
            return response.data;
        } catch (error: any) {
            console.error('Error deleting special date:', error);
            throw new Error(error.response?.data?.error || 'Özel tarih silinemedi');
        }
    },

    // Banner yükle
    async uploadBanner(imageBase64: string, path: string): Promise<{ url: string }> {
        try {
            const response = await api.post('/admin/special-dates/upload-banner', {
                imageBase64,
                path,
            });
            return response.data;
        } catch (error: any) {
            console.error('Error uploading banner:', error);
            throw new Error(error.response?.data?.error || 'Banner yüklenemedi');
        }
    },

    // Banner sil
    async deleteBanner(imageUrl: string): Promise<{ message: string }> {
        try {
            const response = await api.delete('/admin/special-dates/delete-banner', {
                data: { imageUrl },
            });
            return response.data;
        } catch (error: any) {
            console.error('Error deleting banner:', error);
            throw new Error(error.response?.data?.error || 'Banner silinemedi');
        }
    },

    // Gelecek özel tarihleri getir (public)
    async getUpcomingSpecialDates(daysAhead: number = 30): Promise<SpecialDate[]> {
        try {
            const response = await api.get('/web/special-dates', {
                params: { days: daysAhead },
            });
            return response.data;
        } catch (error: any) {
            console.error('Error fetching upcoming special dates:', error);
            throw new Error(error.response?.data?.error || 'Yaklaşan özel tarihler yüklenemedi');
        }
    },

    // Tüm aktif özel tarihleri getir (public)
    async getAllActiveSpecialDates(): Promise<SpecialDate[]> {
        try {
            const response = await api.get('/web/special-dates/all');
            return response.data;
        } catch (error: any) {
            console.error('Error fetching all special dates:', error);
            throw new Error(error.response?.data?.error || 'Özel tarihler yüklenemedi');
        }
    },
};
